import { PreAnnotateModelTypeEnum, PreAnnotateProviderEnum, } from "./preAnnotateSettings.schema";
export const DEFAULT_PRE_ANNOTATE_CONFIG = {
    provider: PreAnnotateProviderEnum.ROBOPIPE_VISION,
    defaultMode: PreAnnotateModelTypeEnum.DETECTION,
    referenceTaskId: null,
};
//# sourceMappingURL=preAnnotateSettings.types.js.map